import React from "react";
import { Container, Content, Header, Heading, Message } from "rsuite";
import css from "./ErrorSection.module.css";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

interface ComponentProps {
    errorMessage: string;
    helpMessage?: string;

    isTitleVisible?: boolean;
}

const ErrorSection: React.FC<ComponentProps> = ({
    errorMessage,
    helpMessage,
    isTitleVisible = true,
}: ComponentProps) => {
    const { t } = useTranslation();

    const title = t("error.header");

    return (
        <Container className={css.pageContainer}>
            {isTitleVisible && (
                <Header>
                    <Heading className={css.pageHeader} level={1}>
                        {title}
                    </Heading>
                </Header>
            )}
            <Content>
                <Message showIcon type="error" title={t("error.reason")}>
                    {parse(errorMessage)}
                </Message>
                <Message
                    className={css.infoMessage}
                    showIcon
                    type="info"
                    title={t("error.possibleFix")}
                >
                    {helpMessage ?? t("error.refreshFix")}
                </Message>
            </Content>
        </Container>
    );
};

export default ErrorSection;
